import styled from 'styled-components';

export const Main = styled.main`
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh; /* fixes mobile browser chrome jump */
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  transition: background-image 0.5s ease-in-out;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const edgePadding = {
  base: '100px',
  lg: '40px',
  md: '24px',
  sm: '20px',
};

export const Content = styled.section`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  width: 100%;
  max-width: 1440px;
  color: ${({ theme }) => theme.palette.text[0]};
  padding: ${({ theme }) => theme.sizes.gap.big} ${edgePadding.base};
  text-align: left;
  align-self: flex-end;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    grid-template-columns: 1fr;
    padding: ${({ theme }) => theme.sizes.gap.big} ${edgePadding.lg};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.sizes.gap.medium} ${edgePadding.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: ${({ theme }) => theme.sizes.gap.normal} ${edgePadding.sm};
    padding-bottom: ${({ theme }) => theme.sizes.gap.big};
  }
`;

export const LeftSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.gap.medium};
  max-width: 780px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    gap: ${({ theme }) => theme.sizes.gap.normal};
  }
`;

export const Logo = styled.div`
  position: absolute;
  left: max(${edgePadding.base}, calc(50% - 720px + ${edgePadding.base}));
  top: ${({ theme }) => theme.sizes.gap.medium};
  z-index: 2;
  display: flex;
  align-items: center;

  svg,
  img {
    height: 50px;
    width: auto;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    left: ${edgePadding.lg};

    svg,
    img {
      height: 46px;
    }
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    left: ${edgePadding.md};
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    left: ${edgePadding.sm};
    top: ${({ theme }) => theme.sizes.gap.normal};

    svg,
    img {
      height: 34px;
    }
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.sizes.gap.normal};
  margin-top: ${({ theme }) => theme.sizes.gap.small};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.sizes.gap.small};

    & > button {
      flex: 0 1 auto;
      width: auto;
      min-width: 0;
      max-width: fit-content;
      padding: 0 ${({ theme }) => theme.sizes.gap.normal};
      font-size: ${({ theme }) => theme.sizes.font.small};
    }
  }
`;
